/**
 * 请求工具类
 * @type {string}
 */
import cookie from 'vue-cookies'
import CryptoJs from './crypto'

export const TOKEN_KEY = 'MasterQi_Token'

/**
 * 设置token
 * @param token
 */
export const setToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token)
  cookie.set(TOKEN_KEY, token, 60 * 60 * 24)
}

export const getToken = () => {
  let token = sessionStorage.getItem(TOKEN_KEY)
  if (token) {
    return token
  }
  let cookieKey = cookie.get(TOKEN_KEY)
  if (cookieKey) {
    token = cookieKey
    sessionStorage.setItem(TOKEN_KEY, token)
    return token
  }
  return false
}
